import { CREATE_HELP_SUPPORT, FETCT_HELP_SUPPORT, CLEAR_HELP_SUPPORT, FETCH_HELP_SUPPORT } from '../../../../Helper/actionsTypes'
import { CRTMSG } from '../../../../Helper/toastmsg'

export const helpSupport = (state = [], action) => {
    const { results, code, message } = action.payload || ''
    switch (action.type) {
        case FETCH_HELP_SUPPORT: {
            return code === 200
                ? { ...state, list: results }
                : { ...state, list: [] }
        }
        case CREATE_HELP_SUPPORT: {
            return code === 200
                ? { ...state, itemAdded: true, message }
                : code === 500
                    ? { ...state, itemAdded: false, badReq: true, message: CRTMSG }
                    : { ...state, itemAdded: false, message }
        }
        case CLEAR_HELP_SUPPORT: {
            return { ...state, itemAdded: null, message: null, list: [] }
        }
        default: return state;
    }
} 